import { IconProps } from "@models/types";
export function GlobeIcon({ className, width, height }: IconProps) {
  return (
    <>
      <svg
        className={className}
        width={width}
        height={height}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <rect x="1.01" y="6.59" width="17.95" height="1.12" rx="0.56" />
        <rect x="1.01" y="12.46" width="17.95" height="1.12" rx="0.56" />
        <g id="Ellipse_68" data-name="Ellipse 68">
          <circle style={{ fill: "none" }} cx="9.99" cy="10.09" r="9.55" />
          <path d="M10,19.67a9.58,9.58,0,1,1,9.57-9.58A9.59,9.59,0,0,1,10,19.67ZM10,1.75a8.34,8.34,0,1,0,8.33,8.34A8.35,8.35,0,0,0,10,1.75Z" />
        </g>
        <path d="M10,19.61c-2.46,0-4.31-4.09-4.31-9.52S7.53.57,10,.57s4.3,4.09,4.3,9.52S12.44,19.61,10,19.61ZM10,1.87c-1.43,0-3,3.52-3,8.22s1.58,8.22,3,8.22,3-3.52,3-8.22S11.41,1.87,10,1.87Z" />
      </svg>
    </>
  );
}
